

export const months = [
    "January",
    "February",
    "March",
    `April`,
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
];

export const monthShortName = [
    "Jan",
    "Feb",
    "Mar",
    `Apr`,
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
];

